export default "__VITE_ASSET__ffe90b44__"